import { createLazyResource, createTriggerResource } from '@magicdoorinc/ui';
import { createMagicDoorContext } from '~/contexts/utils';
// import { leaseInsuranceRepo } from '~/repositories/leaseInsuranceRepository';
import { insuranceRepo } from '~/repositories/settings/insuranceRepository';

export const [LeaseInsuranceProvider, useLeaseInsurance] = createMagicDoorContext('LeaseInsurance', () => {
  const [statistics, { refetch: refetchStatistics }] = createLazyResource(() => insuranceRepo.getStatistics());

  const [leaseInsurances, loadLeaseInsurances, leaseInsurancesActions] = createTriggerResource(async () => {
    try {
      return await insuranceRepo.getStatistics();
    } catch {
      return { items: [] };
    }
  });

  return {
    statistics,
    refetchStatistics,
    leaseInsurances,
    loadLeaseInsurances,
    refetchLeaseInsurances: leaseInsurancesActions.refetch,
  };
});
